module.exports = __webpack_public_path__ + "img/controller_power_consumption.206dbac4.png";